// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_KXx","cls2":"BulkFollowSuggestion-cls2_7DR BulkFollowSuggestion-cls1_KXx"};